import Link from "next/link";
import Image from "next/image";

export default function FooterLogo() {
  return (
    <Link href="/" data-testid="footerLogoLink">
      <Image
        src="/images/RawiahLogos/footerlogo.svg"
        alt="Rawiah"
        width={100}
        height={100}
        quality={1}
        priority={true}
        className="w-32 sm:w-40 md:w-48 lg:w-56 xl:w-64"
      />
    </Link>
  );
}
